export class ApplicationStatuses {
    static AGENT_NO = 'agent_no'
    static AGENT_YES = 'agent_yes'
    static AWAITING_SIGNING = 'awaiting_signing'
    static BEGIN = 'begin'
    static DISCARD = 'discard'
    static DRAFT = 'draft'
    static FSB_BEGIN = 'fsb_begin'
    static FSB_NO = 'fsb_no'
    static FSB_YES = 'fsb_yes'
    static KTSP = 'ktsp'
    static SB_BEGIN = 'sb_begin'
    static SB_NO = 'sb_no'
    static SB_YES = 'sb_yes'
    static SUBDIVISION_NO = 'subdivision_no'
    static SUBDIVISION_YES = 'subdivision_yes'
}
